import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ComponentsModule } from '../../components/components.module';
import { ConseilsComponent } from "./conseils.component";
import { ConseilComponent } from './conseil/conseil.component';

const secondaryRoutes: Routes = [
  {
    path: '',
    component: ConseilsComponent
  },
  {
    path: ':id',
    component: ConseilComponent
  }
];

@NgModule({
  declarations: [
    ConseilsComponent,
    ConseilComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(secondaryRoutes),
    NgbModule,
    ComponentsModule
  ]
})
export class ConseilsModule {
}
